/*
 * Copyright (c) Dito Technologies
 */

import React, {useState} from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {PiecePlayBody_piece$data} from "ui/feature/piece-play/__generated__/PiecePlayBody_piece.graphql";
import PiecePlayModeSelector from "ui/feature/piece-play/PiecePlayModeSelector";
import SimplifiedNoteByNotePlayer from "ui/feature/piece-play/simplified-note-by-note/SimplifiedNoteByNotePlayer";
import Export from "ui/feature/piece-play/export/Export";
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import ListenPlayer from "ui/feature/piece-play/listen/ListenPlayer";
import OnSheetNoteByNotePlayer from "ui/feature/piece-play/on-sheet-note-by-note/OnSheetNoteByNotePlayer";

interface Props {
    piece: PiecePlayBody_piece$data
}

const PiecePlayBody: React.FC<Props> = ({piece}) => {
    const [piecePlayMode, setPiecePlayMode] = useState<PiecePlayMode>("on_sheet_note_by_note");
    const player = React.useMemo(() => {
        switch (piecePlayMode) {
            case "simplified_note_by_note":
                return <SimplifiedNoteByNotePlayer piece={piece}/>;
            case "on_sheet_note_by_note":
                return <OnSheetNoteByNotePlayer piece={piece} />
            case "listen":
                return <ListenPlayer piece={piece}/>
            case "export":
                return <Export piece={piece}/>;
        }
    }, [piecePlayMode, piece]);
    return (
        <DndProvider backend={HTML5Backend}>
            <div>
                <PiecePlayModeSelector selectedMode={piecePlayMode} selectMode={setPiecePlayMode}/>
                {player}
            </div>
        </DndProvider>
    );
}

export default createFragmentContainer(PiecePlayBody, {
    piece: graphql`
    fragment PiecePlayBody_piece on MusicPiece {
        id
        ...ListenPlayer_Piece
        ...SimplifiedNoteByNotePlayer_Piece
        ...OnSheetNoteByNotePlayer_Piece
        ...Export_Piece
    }
    `
});